import { getLocalDateFromTimestamp } from '@utils/date'
import Image from 'next/image'
import styles from './storiesSection.module.scss'

const readTimeIcon = 'https://acko-cms.ackoassets.com/clock_2e00e50da6.svg'

interface StoryBylineSectionProps {
  readTime?: number
  contentType?: string
  publishedAt?: string
}

const StoryBylineSection: React.FC<StoryBylineSectionProps> = ({ readTime, contentType, publishedAt }) => (
    <div className={styles.bylineSection}>
      <div className={styles.readTimeSection}>
        <Image src={readTimeIcon} width={16} height={16} alt="Read time icon" loading="lazy" />
        {readTime} min read
      </div>
      <div className={styles.separator} />
      <div className={`${styles.contentTypeSection} ${styles.showDesktopOnly}`}>
        Published in&nbsp;<span className={styles.contentTypeBold}>{contentType}</span>
      </div>
      <div className={`${styles.separator} ${styles.showDesktopOnly}`} />
      <div className={styles.publishedAtSection}>{getLocalDateFromTimestamp(publishedAt)}</div>
    </div>
  )

export default StoryBylineSection
